import React from "react";
import { Menu, Badge } from "antd";
import { useQuery } from "@apollo/client";
import Icon from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

import { ReactComponent as MailboxIcon } from "assets/icons/my_mailbox.svg";
import { ReactComponent as ProfileIcon } from "assets/icons/my_profile.svg";
import { ReactComponent as SettingIcon } from "assets/icons/my_settings.svg";
import { ReactComponent as BillingIcon } from "assets/icons/my_billing.svg";
import { ReactComponent as CertificateIcon } from "assets/icons/my_certificates.svg";
import { ReactComponent as SignoutIcon } from "assets/icons/sign_out.svg";
import { ReactComponent as GoToChinaIcon } from "assets/icons/go_to_china.svg";
import { ReactComponent as HelpIcon } from "assets/icons/help.svg";
import { ReactComponent as ForumIcon } from "assets/icons/forum.svg";
import { ReactComponent as GiftIcon } from "assets/icons/gift-solid.svg";

import GET_UNREAD_NOTIFICATIONS from "graphql/queries/GetUnreadNotifications";

import { useTranslation } from "react-i18next";

import * as Layout from "common/layout";

const MyProfileSider = (props: any) => {
  const { t } = useTranslation("my_profile");
  const navigate = useNavigate();
  const forumUrl =
    process.env.REACT_APP_DISCOURSE_FORUM_URL ||
    `${window.location.origin}/forum`;
  const { currentPathname, logOut } = props;

  const { data } = useQuery(GET_UNREAD_NOTIFICATIONS, {
    fetchPolicy: "network-only",
  });

  const { unreadNotificationsCount } = data?.me || {};

  const handleClickMenuItem = (key: number | string) => {
    if (key === "sign-out") {
      logOut();
      navigate("/login");
    } else if (key === "forum") {
      window.open(forumUrl, "_blank");
    } else if (key === "go-to-china") {
      window.open(t("GOTO_CHINA_PAGE_URL"), "_blank");
    } else if (key === "help") {
      window.open(t("HELP_PAGE_URL"), "_blank");
    } else {
      navigate(`/account/${key}`);
    }
  };

  return (
    <Layout.Sider>
      <Menu
        mode="inline"
        theme="dark"
        onClick={({ key }) => handleClickMenuItem(key)}
        selectedKeys={[currentPathname]}
      >
        <Menu.Item
          key="my-mailbox"
          icon={<Icon component={MailboxIcon} width="2em" height="2em" />}
        >
          {t("MY MAILBOX")}
          <Badge
            count={unreadNotificationsCount}
            style={{
              fontWeight: "bold",
              backgroundColor: "#fdd440",
              color: "#00538b",
              marginLeft: "12px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              letterSpacing: "0px",
            }}
          />
        </Menu.Item>
        <Menu.Item key="refer-a-friend" icon={<Icon component={GiftIcon} />}>
          {t("REFER A FRIEND")}
        </Menu.Item>
        <Menu.Item key="my-profile" icon={<Icon component={ProfileIcon} />}>
          {t("MY PROFILE")}
        </Menu.Item>
        <Menu.Item key="forum" icon={<Icon component={ForumIcon} />}>
          {t("DISCORD_FORUM")}
        </Menu.Item>
        <Menu.Item key="go-to-china" icon={<Icon component={GoToChinaIcon} />}>
          {t("GO TO CHINA")}
        </Menu.Item>
        <Menu.Item key="my-settings" icon={<Icon component={SettingIcon} />}>
          {t("MY SETTINGS")}
        </Menu.Item>
        <Menu.Item key="my-billings" icon={<Icon component={BillingIcon} />}>
          {t("MY BILLING")}
        </Menu.Item>
        <Menu.Item
          key="my-certificates"
          icon={<Icon component={CertificateIcon} />}
        >
          {t("MY CERTIFICATES")}
        </Menu.Item>
        <Menu.Item key="help" icon={<Icon component={HelpIcon} />}>
          {t("HELP")}
        </Menu.Item>
        <Menu.Item key="sign-out" icon={<Icon component={SignoutIcon} />}>
          {t("SIGN OUT")}
        </Menu.Item>
      </Menu>
    </Layout.Sider>
  );
};

export default MyProfileSider;
